export const course_number = 'CMSC471'
export const course_full_name = 'Introduction to Information Visualization'
export const course_sub_name = ''
export const course_short_name = 'introvis'
export const course_time = 'MW 2:00pm - 3:15pm'
export const semester = 'Spring 2026'

export const course_objective_long = `
<p>
<b>Description</b>&#8212;Datasets are becoming increasingly large and complex, requiring intuitive ways to explore and interpret them quickly and efficiently. In this case, a picture is worth a thousand words: visualizations enable us to transform data into images that are easier to understand and reason about, compared to raw numbers and raw text. Visualizations are critical tools in externalizing and organizing our knowledge and insights, whether to explore collected datasets to improve our understanding of the physical world, to assess and debug analysis/experimental workflows, or to present new and interesting results to diverse audiences. In this course we will study techniques and algorithms for creating effective visualizations based on principles from graphic design, perceptual psychology, and cognitive science. Students will learn how to design and build interactive visualizations for the web, using the D3.js (Data-Driven Documents) framework.

</p>

<p>
<b>Course objectives</b>&#8212;By the end of this course, students can
<ul>
<li>understand key visualization techniques and theory.</li>
<li>implement interactive data visualizations using D3.js.</li>
<li>design, evaluate, and critique visualization designs.</li>
<li>develop a substantial visualization project.</li>
</ul>
</p>


<p><b>Note</b>: We reserve the right to add, remove, or alter the syllabus as needed throughout the semester. Major changes will be notified before the release. </p>


`


export const course_location = `CSI 3117`

export const syllabus_intro = ` Most materials will be released publicly on this website. Confidential content will be released on a UMD google drive or through Canvas. As all these topics are related to visualization, I sometimes omit the word "Visualization" in the lecture title for brevity. <br/>

&#128187; = programming labs; 	&#128397; = non-programming design labs; &#129302 = vibe coding option; &#128172; = discussion labs`


export const howitworks =`
<p>We expect students to submit each lab <b>by the end of class or by the following Wednesday</b>. Labs are graded at the time of submission. Programming assignments are graded as a demo (we also look at code briefly).
</p>

<p>To ensure efficient communication, we  <b>don't reply to course-related emails during the semester</b>. Please use <b>Piazza</b> for questions—it notifies us immediately.</p>

`



export const assignments = [
    
    {
        'name': 'In-class labs (solo)',
        'summary': '',
        'divs': [
            {
                'perc': .35,
                'id': 'labs',
                'requirement': `(11 programming labs * 3%) + 1 design lab * 2% = 35%. Students are encouraged to ask questions in class and talk to each other.`,
                'long_requirement': null
            }]
    },
    {
        'name': 'Assignments (2-3 people)',
        'summary': '',
        'divs': [
            {
                'perc': .13,
                'id': 'a1',
                'requirement': '<a href="handouts/A1-interactive.html">A1: Interactive Visualization</a>',
                'long_requirement': null
            },
            {
                'perc': .13,
                'id': 'a2',
                'requirement': '<a href="handouts/A2-hat.html">A2: White Hat / Black Hat Visualization</a>',
                'long_requirement': null
            }]
    },
    {
        'name': 'Final Assessment: Final Project (3-5 people)',
        'summary': '',
        'divs': [
            {
                'perc': .36,
                'id': 'final',
                'requirement': '<a href="handouts/FP.html">Final project instructions</a>: proposal (3%), demo (20%), oral (3%), teamwork (3%), and code quality (3%). Discussion and milestone labs worth additional 4%.',
                'long_requirement': ``
            }]
    }
    ,
    {
        'name': 'Lecture Participation',
        'summary': '',
        'divs': [
            {
                'perc': .03,
                'id': 'participation',
                'requirement': 'Participate in at least 6 lectures (the first Introduction lecture counts).',
                'long_requirement': ``
            }]
    }
]




export const syllabus = `
| Week | Mon | Lecture | Wed  |  In-class Lab | Assignment |

|------|----------|------------|------| ------------|------|

| 1    | 01/26/2026       |      (school closed)   ☃️       | 01/28/2026               |   (school closed) ☃️       |    [Lab [##X] out](handouts/lab0-handout.html) (offline)          |

| 2    | 02/02/2026       |  Introduction [[html]](slides/w1-intro/index.html) [[pdf]](slides/w1-intro.pdf)  | 02/04/2026               |    Lab [##X]: &#128187; Intro to D3 [[html]](handouts/lab1-handout.html)     |          |

| 3    | 02/09/2026       |    Visual Encodings [[html]](slides/w2-encoding/index.html) [[pdf]](slides/w2-encoding.pdf)   | 02/11/2026               |  Lab [##X]: &#128187;  A Basic Bar Chart [[html]](handouts/lab2-handout.html)     |  [A1](handouts/A1-interactive.html) out, L0-1 due       |

| 4    | 02/16/2026       |    Perception & Cognition  [[html]](slides/w3-perception_and_cognition/index.html) [[pdf]](slides/w3-perception_and_cognition.pdf)              |02/18/2026               |   Lab [##X]: &#128187; Enter, Update, and Exit [[html]](handouts/lab3-handout.html)    |    L2 due     |

| 5    | 02/23/2026       |    Task & Interaction   [[pdf]](slides/w4-interaction.pdf)   |02/25/2026               |    Lab [##X]:  &#128187; Interaction & Animation I [[html]](handouts/lab4-5-handout.html)       |     L3 due  |

| 6    | 03/02/2026       |     Animation   [[pdf]](slides/w5-animation.pdf)   | 03/04/2026               |    Lab [##X]:  &#128187; Interaction & Animation II   [[html]](handouts/lab4-5-handout.html)      |    L4-5 due, A1 due       |

| 7    | 03/09/2026       |     Color Theory   [[html]](slides/w6-color/index.html)  [[pdf]](slides/w6-color.pdf)       |03/11/2026               |   Lab [##X]: 	&#128397;  EDA & Tableau     [[html]](handouts/lab6-handout.html)     |  [A2](handouts/A2-hat.html)  out; L6 due   |

| 8  | 03/16/2026       |       Spring Break | 03/18/2026            | Spring Break  |            |          |

| 9    | 03/23/2026       |    Storytelling & Narrative [[pdf]](slides/w9-storytelling.pdf)    | 03/25/2026               |   Lab [##X]:  &#128187; Layout [[html]](handouts/lab7-handout.html)  |  [FP](handouts/FP.html) out        |

| 10   | 03/30/2026       |     Tree & Graph    [[pdf]](slides/w10-tree.pdf)      | 04/01/2026               |   Lab [##X]:  &#128187; "Spiral Days"  I [[html]](handouts/lab8-9-handout.html)    |  L7 due      |

| 11   | 04/06/2026       |      Time & Multivariate  [[pdf]](slides/w11-time.pdf) [[doc]](https://docs.google.com/document/d/1XEMr7BKnDUy-MTAiCF0Yp7ss91A5vHnth2yBMOzacTM/edit?usp=sharing)        | 04/08/2026         |   Lab [##X]:  &#128187; "Spiral Days" II  [[html]](handouts/lab8-9-handout.html)         |   A2 due,  L8-9 due   |

| 12   | 04/13/2026       |    Data Journalism & Map   [[pdf]](slides/w12-map.pdf)  | 04/15/2026               |  Lab [##X]: &#128172;   Project Discussion  [[html]](handouts/FP-discussion.html)  |  FP proposal due     |

| 13   | 04/20/2026       |       Interpretability & Explainability [[pdf]](slides/w13-interpretability.pdf)     | 04/22/2026               |    Lab [##X]:   &#129302; Vibe Coding    [[html]](handouts/lab11-handout.html)  |       |

| 14   | 04/27/2026       |     Uncertainty & Probability [[pdf]](slides/w14-uncertainty.pdf)        | 04/29/2026               |   Lab [##X]:  &#129302; U.S. Election Map   [[html]](handouts/lab12-handout.html) |     L11 due        |

| 15   | 05/04/2026       |     Lab [##X]: &#128172; Final Project Milestone  [[html]](handouts/FP-milestone.html)               | 05/06/2026               |    Final Project Clinic Day      |  L12 due      |

| 16   | 05/14/2026       |   Final Project Demo 4-6pm   | 05/16/2026               |     |    Final Project due     |
`

export const collaboration_policy = `
<p> 
We encourage collaboration and discussion among students. You are welcome to seek help from the course staff during office hours or use Piazza to ask questions and discuss with other students. For group projects, collaboration is encouraged on all aspects of the project and the writeup.
</p>
`

export const late_policy = `
<p>
<ul>
<li>You have <b>a total of 4 slack days</b> to use for <b>assignments or FP proposal</b>.  These days are intended for minor illnesses, special occasions (e.g., interviews), or unexpected scenarios. Final project demos can't be delayed.</li>
<li>The same number of slack days applies to all team members.</li>
<li>If you want to use slack days for an assignment, please make <b>a placeholder submission  before the deadline in Canvas-ELMS</b> to specify how many days you'd like to use. Also remember to <b>add a note in your final submission</b> so we know you used slack days.</li>
<li>Late assignments not covered by a slack day will incur a 10% grade deduction per day.</li>
<li><b>Labs</b> are already quite flexible in terms of submission timing, so we don’t offer extra slack days. That said, consistently submitting labs late will result in a <b>33% deduction for each week late</b>.</li>
</ul>
</p>
<p>
<b>Per university policy</b>: any student who needs to be excused for an absence must notify the instructor in a timely manner. The notification should be provided either prior to the absence or as soon afterwards as possible.
</p>
`

export const ai_policy = ` <p>The scope of AI tools includes, but is not limited to, GPT, Claude, Gemini, DALL-E, Midjourney, and Copilot. 
</p>
<p>
We encourage students to use them responsibly while adhering to academic integrity standards. Here are our policies and guidelines for using AI tools: 
  <ul>
    <li>
      <b>Permitted uses:</b> AI tools may be used for brainstorming, generating ideas,
      improving writing clarity, debugging code, and explaining concepts or code snippets.
    </li>
    <li>
      <b>Prohibited uses for labs:</b> Using AI tools to <b>directly complete labs</b>
      is strictly prohibited unless it is designed so. If such use is identified, the corresponding lab will receive a
      <b>66% score reduction</b>.
    </li>
    <li>
      <b>Conceptual understanding checks:</b> During lab checkouts, we may ask conceptual
      questions related to the lab to ensure understanding. Repeated inability to answer these
      questions will result in an additional <b>33% deduction</b>.
    </li>
    <li>
      <b>Assignments and final project:</b> You may use AI coding tools or generative AI for
      the two assignments and the final project. We encourage you to disclose all AI use
      in your writeup (what tools you used and how they contributed).
    </li>
    <li>
      <b>Extra credit:</b> Creative, thoughtful, and well-documented uses of AI tools in
      assignments may be eligible for <b>extra credit</b>.
    </li>
    <li>
      <b>Responsibility and verification:</b> AI tools can produce incorrect, misleading, or
      non-functional outputs. You are responsible for verifying all AI-generated content and
      ensuring your submitted work reflects your own understanding.
    </li>
  </ul>

</p>

<p>

De-identified and aggregated submissions and responses may be used for research on instructional practices; this does not affect grades or course standing. 
Students who feel uncomfortable may contact the course staff to request that their work be excluded without penalty.
</p>
             
`

{/* <ul>
<li>AI should <b>not</b> be used to <b>directly</b> complete <b>labs</b> but you can use them in assisting in assignments, although we advise on ask AI to generate only small functions upon your own design.</li>
<li>Clearly <b>mark</b> any content that is directly generated by AI. </li>
<li>Be mindful about your <b>reliance</b> on AI, especially in terms of <b>trusting</b> AI-generated content. </li>
<li>You may use AI to <b>assist</b> with coursework, such as inquiring about terms, brainstorming, and improving writing. </li>
<li>You are encouraged to use AI <b>creatively</b> (in a good way)and share your thoughts and experiences with us.</li>
<li>Violations will result in a zero for the affected portion.</li>
</ul> */}

export const support_text = `
We are committed to the full inclusion of all students. You should expect and demand respect from classmates and staff, and reciprocally, treat others with respect. If any incident challenges this commitment, please inform us immediately.

If you have a disability or condition that requires accommodations, please notify us early in the term. You can speak with us after class. For more information, contact Accessibility & Disability Services at (301) 314-7682 or adsfrontdesk@umd.edu.

For accessibility, please view <a href="https://www.umd.edu/web-accessibility" target="_blank" title="UMD Web Accessibility">Web Accessibility</a>.
`



export const acknowledgement = `
<p>The content of this class has been inspired by the classes and talks given by the following people:  
<b>Remco Chang</b> at Tufts University (<a href='https://www.fmyang.com/2015fallVISweb/public_html/'>COMP150VIZ</a>), 
<b>Arvind Satyanarayan</b> at MIT (<a href='https://vis.csail.mit.edu/classes/6.859/'>6.859</a>), 
<b>Matthew Kay</b> and <b>Maryam Hedayati</b> at Northwestern University (<a href='https://www.mccormick.northwestern.edu/computer-science/academics/courses/descriptions/333.html'>COMP_SCI 333</a> and their talks), 
<b>Leo Zhicheng Liu</b> at the University of Maryland College Park (CMSC471), 
<b>Paul Rosen</b> and <b>Alexander Lex</b> at The University of Utah (<a href='https://www.dataviscourse.net/2024/index.html'>DS-4630/CS-5630/CS-6630</a>), 
<b>Leilani Battle</b> and <b>Jeff Heer</b> at University of Washington (<a href='https://courses.cs.washington.edu/courses/cse442/'>CSE442/CSE512</a>), 
<b>Lane Harrison</b> at WPI (<a href='https://users.wpi.edu/~ltharrison/biovis/'>BCB 4002/502; CS 4802/582</a>), <b>Adam Perer</b> at Carnegie Mellon University (<a href='https://www.hcii.cmu.edu/course/interactive-data-science'>05-839</a>), 
 and <b>Karen Schloss</b> at the University of Wisconsin–Madison.

`